import { Grid } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import SimpleCard from '../../utils/card';
import { ROL_USER } from '../../app/api-client/constants';

export const HomeSuport = (props) => {

    const rol = localStorage.getItem(ROL_USER);

    const history = useHistory();



    const handleBasculas = () => {
        history.push(`/basculas/`);
    }


    return (
        <Grid container spacing={1} style={{ marginBottom: '35%', marginTop: '2%', marginLeft: 0, marginRight: 0 }}>
            {rol === "ROLE_SUPPORT" &&
                <SimpleCard
                    title="Estaciones"
                    messageInfo="Administración de estaciones de tele salud"
                    img="bascula"
                    event={handleBasculas}
                />
            }

        </Grid>

    );
}
